/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function IconTitleDescriptionList({ objsArray }) {
  return (
    <Grid container alignItems="center" width={"100%"}>
      {objsArray.map((contentsObj, index) => (
        <React.Fragment key={index}>
          <Grid item xs={12} sm={contentsObj.gridRatio[0]}>
            <MKBox
              display="flex"
              // pr={5}
              // py={2}
              width="100%"
              height="auto"
              alignItems="center"
              justifyContent="center"
              borderRadius="xl"
            >
              {contentsObj.icon && (
                <Icon fontSize="large" color={contentsObj.color}>
                  {contentsObj.icon}
                </Icon>
              )}
              {contentsObj.image && (
                <MKBox
                  component="img"
                  src={contentsObj.image}
                  alt={contentsObj.title}
                  width="100%"
                  borderRadius="100%"
                  shadow="lg"
                />
              )}
            </MKBox>
          </Grid>
          <Grid item xs={12} sm={contentsObj.gridRatio[1]}>
            <MKBox display="flex" flexDirection="column" pb={2}>
              <MKBox>
                <MKTypography variant="body1" color="text" pl={2}>
                  {contentsObj.title}
                </MKTypography>
              </MKBox>
              <MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  {contentsObj.description}
                </MKTypography>
              </MKBox>
            </MKBox>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}

IconTitleDescriptionList.propTypes = {
  objsArray: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      image: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      gridRatio: PropTypes.arrayOf(PropTypes.number).isRequired,
      color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "light",
        "text",
      ]),
    })
  ).isRequired,
};
export default IconTitleDescriptionList;
